// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import SoportePage from "../pages/Soporte/Soporte";
const __wvcRoutePaths = ["/SoportePage", "/soporte"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutpage", "aviso-de-privacidad", "blog", "blogpage", "contacto", "contactpage", "diagnostico", "diagnosticopage", "homepage", "inicio", "methodologypage", "metodologia", "partner", "partnerpage", "post", "privacynoticepage", "servicespage", "servicios", "sobre", "soporte", "soportepage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<SoportePage />} />
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<SoportePage />} />
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
